module.exports = __webpack_public_path__ + "assets/img/Clipboard4@2x.bb3a41b3.jpg";